import * as React from "react";
import { Route } from "react-router";

import MainPage from "./MainPage";
import Pushy from "./Pushy";

const MainLayout: React.FC = () => {
  const [showLoading, setShowLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    document.addEventListener("DOMContentLoaded", () => {
      setShowLoading(!(document.readyState === "complete"));
    });
    return () => {
      document.removeEventListener("DOMContentLoaded", () => {
        setShowLoading(!(document.readyState === "complete"));
      });
    };
  }, [showLoading]);

  return (
    <>
      <div id="pushy-overlay" className="pushy-overlay"></div>
      <div id="popup-overlay" className="popup-overlay"></div>
      <Pushy />
      {/* TODO: Something broken need to investigate, and then enable loading */}
      {/* <Loading show={showLoading} /> */}
      <Route path="/" component={MainPage} />
    </>
  );
};

export default MainLayout;
